import { ratio, normalize } from 'yankees-react-utils';

const pitchFXERA = (rvpitchfx, pitchfxwrv) => {
    const rv = rvpitchfx / pitchfxwrv;
    return (4.4695 + (-136.900000 * rv));
};

const hitFXERA = (rvhitfxpit, pawrv) => {
    if (pawrv === 0) return 0;
    return (4.6062 + ((rvhitfxpit / pawrv) * 37.42133) + ((rvhitfxpit / pawrv) * (rvhitfxpit / pawrv) * 88.77471));
};

const wayAheadSO = (pitches) => {
    const waPA = new Set([...pitches.filter((p) => p.balls <= 1 && p.strikes === 2).map((p) => p.eventseq)]);
    const waSO = new Set([...pitches.filter((p) => p.balls <= 1 && p.strikes === 2 && p.so === 1).map((p) => p.eventseq)]);
    return ratio(waPA, waSO);
};

const RVPerN = (rv, pa, n) => {
    if (pa === 0) return null;
    const v = (n * rv / pa);

    if (!Number.isFinite(v)) return null;

    return v;
};

const rvPer100BIP = (rv, bip) => normalize(rv, bip, 100);

export {
    pitchFXERA,
    hitFXERA,
    wayAheadSO,
    RVPerN,
    rvPer100BIP,
};
